<app-dc-pane
  [noHeader]="true"
  [loading]="loading"
  [noScrollBar]="true"
  [tableContainer]="true"
>
  <app-dc-table
    #table
    [rows]="rows"
    [columns]="columns"
    [messages]="messages"
    [sort]="sortOrder"
    [scrollV]="true"
    [showFooter]="true"
    (action)="tableAction($event)"
    (activate)="tableActivate($event)"
    [pageData]="pageData"
    (page)="pageChange($event)"
  ></app-dc-table>
  <div *ngIf="rows.length == 0">
    <p class="p-2 noProducts">No Products Found.</p>
  </div>
</app-dc-pane>
